/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientResource } from './';
import {
    ClientResourceFromJSON,
    ClientResourceFromJSONTyped,
    ClientResourceToJSON,
} from './';
import type { ContractResource } from './';
import {
    ContractResourceFromJSON,
    ContractResourceFromJSONTyped,
    ContractResourceToJSON,
} from './';
import type { CustomerSuccessManagerResource } from './';
import {
    CustomerSuccessManagerResourceFromJSON,
    CustomerSuccessManagerResourceFromJSONTyped,
    CustomerSuccessManagerResourceToJSON,
} from './';
import type { FreelancerResource } from './';
import {
    FreelancerResourceFromJSON,
    FreelancerResourceFromJSONTyped,
    FreelancerResourceToJSON,
} from './';
import type { LotResource } from './';
import {
    LotResourceFromJSON,
    LotResourceFromJSONTyped,
    LotResourceToJSON,
} from './';
import type { ProjectInformationResourceBudgetConsumption } from './';
import {
    ProjectInformationResourceBudgetConsumptionFromJSON,
    ProjectInformationResourceBudgetConsumptionFromJSONTyped,
    ProjectInformationResourceBudgetConsumptionToJSON,
} from './';
import type { ProjectInformationResourceFreelancerAppraisal } from './';
import {
    ProjectInformationResourceFreelancerAppraisalFromJSON,
    ProjectInformationResourceFreelancerAppraisalFromJSONTyped,
    ProjectInformationResourceFreelancerAppraisalToJSON,
} from './';
import type { ProjectInformationResourceOptions } from './';
import {
    ProjectInformationResourceOptionsFromJSON,
    ProjectInformationResourceOptionsFromJSONTyped,
    ProjectInformationResourceOptionsToJSON,
} from './';
import type { ProjectInformationResourceQuoteLinesInner } from './';
import {
    ProjectInformationResourceQuoteLinesInnerFromJSON,
    ProjectInformationResourceQuoteLinesInnerFromJSONTyped,
    ProjectInformationResourceQuoteLinesInnerToJSON,
} from './';
import type { ProjectInformationResourceValidationInfo } from './';
import {
    ProjectInformationResourceValidationInfoFromJSON,
    ProjectInformationResourceValidationInfoFromJSONTyped,
    ProjectInformationResourceValidationInfoToJSON,
} from './';
import type { ProjectStatus } from './';
import {
    ProjectStatusFromJSON,
    ProjectStatusFromJSONTyped,
    ProjectStatusToJSON,
} from './';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInformationResource
 */
export interface ProjectInformationResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    projectId: string;
    /**
     * 
     * @type {ContractResource}
     * @memberof ProjectInformationResource
     */
    contract: ContractResource;
    /**
     * 
     * @type {FreelancerResource}
     * @memberof ProjectInformationResource
     */
    freelancer: FreelancerResource;
    /**
     * 
     * @type {ClientResource}
     * @memberof ProjectInformationResource
     */
    client: ClientResource;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof ProjectInformationResource
     */
    projectStatus: ProjectStatus;
    /**
     * Current clock of the project (time machine)
     * @type {Date}
     * @memberof ProjectInformationResource
     */
    currentDatetime?: Date;
    /**
     * 
     * @type {LotResource}
     * @memberof ProjectInformationResource
     */
    lot: LotResource;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    projectDuration?: string;
    /**
     * Is the current user the owner of the project or an admin of the project company
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    participant: boolean;
    /**
     * 
     * @type {WorkedUnit}
     * @memberof ProjectInformationResource
     */
    freelancerWorkedUnit?: WorkedUnit;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResource
     */
    freelancerWorkedRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResource
     */
    freelancerWorkedFrequency?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResource
     */
    freelancerEstimatedTotalWorkedAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    freelancerLegalDocumentCanBeDownloaded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    clientReference?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    renewStatus: ProjectInformationResourceRenewStatusEnum;
    /**
     * * MISSION_SUMMARY : /mission/pdf/{missionId}/summary
     * * MISSION_BUNDLE : /project-invoices/bundle/pdf/{missionId}
     * * INVOICE : /invoice/pdf/{invoiceId}
     * * MISSION_ORDER : /mission/pdf/{missionId}
     * * PROFORMA : /mission/pdf/{missionId}/proforma-invoice
     * * MISSION_SUMMARY_WITH_CONDITIONS : /mission/pdf/{missionId}/summary?withConditions=true
     * * MISSION_WITH_CONDITIONS : /mission/pdf/{missionId}?withConditions=true
     * 
     * @type {Array<string>}
     * @memberof ProjectInformationResource
     */
    invoiceOrderSummaryTypes: Array<ProjectInformationResourceInvoiceOrderSummaryTypesEnum>;
    /**
     * if projectStartDate and projectEndDate are required on POST
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    projectPeriodRequired: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    canAddExtraDocument?: boolean;
    /**
     * 
     * @type {ProjectInformationResourceOptions}
     * @memberof ProjectInformationResource
     */
    options: ProjectInformationResourceOptions;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    clientBelongsToAWalletCompany: boolean;
    /**
     * 
     * @type {Array<ProjectInformationResourceQuoteLinesInner>}
     * @memberof ProjectInformationResource
     */
    quoteLines?: Array<ProjectInformationResourceQuoteLinesInner>;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    additionalNotes?: string;
    /**
     * 
     * @type {ProjectInformationResourceFreelancerAppraisal}
     * @memberof ProjectInformationResource
     */
    freelancerAppraisal?: ProjectInformationResourceFreelancerAppraisal;
    /**
     * 
     * @type {ProjectInformationResourceValidationInfo}
     * @memberof ProjectInformationResource
     */
    validationInfo?: ProjectInformationResourceValidationInfo;
    /**
     * 
     * @type {ProjectInformationResourceBudgetConsumption}
     * @memberof ProjectInformationResource
     */
    budgetConsumption?: ProjectInformationResourceBudgetConsumption;
    /**
     * Whether the project completion already requested by the client or the freelancer
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    completionRequested: boolean;
    /**
     * Whether the company allow expense tracker
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    expenseTrackerEnable?: boolean;
    /**
     * The service level of the company
     * @type {string}
     * @memberof ProjectInformationResource
     */
    clientCompanyServiceLevel?: ProjectInformationResourceClientCompanyServiceLevelEnum;
    /**
     * 
     * @type {CustomerSuccessManagerResource}
     * @memberof ProjectInformationResource
     */
    customerSuccessManager?: CustomerSuccessManagerResource;
}


/**
 * @export
 */
export const ProjectInformationResourceRenewStatusEnum = {
    Renewable: 'RENEWABLE',
    AlreadyRenew: 'ALREADY_RENEW'
} as const;
export type ProjectInformationResourceRenewStatusEnum = typeof ProjectInformationResourceRenewStatusEnum[keyof typeof ProjectInformationResourceRenewStatusEnum];

/**
 * @export
 */
export const ProjectInformationResourceInvoiceOrderSummaryTypesEnum = {
    MissionSummary: 'MISSION_SUMMARY',
    MissionBundle: 'MISSION_BUNDLE',
    Invoice: 'INVOICE',
    MissionOrder: 'MISSION_ORDER',
    Proforma: 'PROFORMA',
    MissionSummaryWithConditions: 'MISSION_SUMMARY_WITH_CONDITIONS',
    MissionWithConditions: 'MISSION_WITH_CONDITIONS'
} as const;
export type ProjectInformationResourceInvoiceOrderSummaryTypesEnum = typeof ProjectInformationResourceInvoiceOrderSummaryTypesEnum[keyof typeof ProjectInformationResourceInvoiceOrderSummaryTypesEnum];

/**
 * @export
 */
export const ProjectInformationResourceClientCompanyServiceLevelEnum = {
    Standard: 'STANDARD',
    Advanced: 'ADVANCED',
    Corporate: 'CORPORATE'
} as const;
export type ProjectInformationResourceClientCompanyServiceLevelEnum = typeof ProjectInformationResourceClientCompanyServiceLevelEnum[keyof typeof ProjectInformationResourceClientCompanyServiceLevelEnum];


/**
 * Check if a given object implements the ProjectInformationResource interface.
 */
export function instanceOfProjectInformationResource(value: object): value is ProjectInformationResource {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('projectStatus' in value) || value['projectStatus'] === undefined) return false;
    if (!('lot' in value) || value['lot'] === undefined) return false;
    if (!('participant' in value) || value['participant'] === undefined) return false;
    if (!('renewStatus' in value) || value['renewStatus'] === undefined) return false;
    if (!('invoiceOrderSummaryTypes' in value) || value['invoiceOrderSummaryTypes'] === undefined) return false;
    if (!('projectPeriodRequired' in value) || value['projectPeriodRequired'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('clientBelongsToAWalletCompany' in value) || value['clientBelongsToAWalletCompany'] === undefined) return false;
    if (!('completionRequested' in value) || value['completionRequested'] === undefined) return false;
    return true;
}

export function ProjectInformationResourceFromJSON(json: any): ProjectInformationResource {
    return ProjectInformationResourceFromJSONTyped(json, false);
}

export function ProjectInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'contract': ContractResourceFromJSON(json['contract']),
        'freelancer': FreelancerResourceFromJSON(json['freelancer']),
        'client': ClientResourceFromJSON(json['client']),
        'projectStatus': ProjectStatusFromJSON(json['projectStatus']),
        'currentDatetime': json['currentDatetime'] == null ? undefined : (new Date(json['currentDatetime'])),
        'lot': LotResourceFromJSON(json['lot']),
        'projectDuration': json['projectDuration'] == null ? undefined : json['projectDuration'],
        'participant': json['participant'],
        'freelancerWorkedUnit': json['freelancerWorkedUnit'] == null ? undefined : WorkedUnitFromJSON(json['freelancerWorkedUnit']),
        'freelancerWorkedRate': json['freelancerWorkedRate'] == null ? undefined : json['freelancerWorkedRate'],
        'freelancerWorkedFrequency': json['freelancerWorkedFrequency'] == null ? undefined : json['freelancerWorkedFrequency'],
        'freelancerEstimatedTotalWorkedAmount': json['freelancerEstimatedTotalWorkedAmount'] == null ? undefined : json['freelancerEstimatedTotalWorkedAmount'],
        'freelancerLegalDocumentCanBeDownloaded': json['freelancerLegalDocumentCanBeDownloaded'] == null ? undefined : json['freelancerLegalDocumentCanBeDownloaded'],
        'clientReference': json['clientReference'] == null ? undefined : json['clientReference'],
        'renewStatus': json['renewStatus'],
        'invoiceOrderSummaryTypes': json['invoiceOrderSummaryTypes'],
        'projectPeriodRequired': json['projectPeriodRequired'],
        'canAddExtraDocument': json['canAddExtraDocument'] == null ? undefined : json['canAddExtraDocument'],
        'options': ProjectInformationResourceOptionsFromJSON(json['options']),
        'clientBelongsToAWalletCompany': json['clientBelongsToAWalletCompany'],
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(ProjectInformationResourceQuoteLinesInnerFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
        'freelancerAppraisal': json['freelancerAppraisal'] == null ? undefined : ProjectInformationResourceFreelancerAppraisalFromJSON(json['freelancerAppraisal']),
        'validationInfo': json['validationInfo'] == null ? undefined : ProjectInformationResourceValidationInfoFromJSON(json['validationInfo']),
        'budgetConsumption': json['budgetConsumption'] == null ? undefined : ProjectInformationResourceBudgetConsumptionFromJSON(json['budgetConsumption']),
        'completionRequested': json['completionRequested'],
        'expenseTrackerEnable': json['expenseTrackerEnable'] == null ? undefined : json['expenseTrackerEnable'],
        'clientCompanyServiceLevel': json['clientCompanyServiceLevel'] == null ? undefined : json['clientCompanyServiceLevel'],
        'customerSuccessManager': json['customerSuccessManager'] == null ? undefined : CustomerSuccessManagerResourceFromJSON(json['customerSuccessManager']),
    };
}

export function ProjectInformationResourceToJSON(value?: ProjectInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectId': value['projectId'],
        'contract': ContractResourceToJSON(value['contract']),
        'freelancer': FreelancerResourceToJSON(value['freelancer']),
        'client': ClientResourceToJSON(value['client']),
        'projectStatus': ProjectStatusToJSON(value['projectStatus']),
        'currentDatetime': value['currentDatetime'] == null ? undefined : ((value['currentDatetime']).toISOString()),
        'lot': LotResourceToJSON(value['lot']),
        'projectDuration': value['projectDuration'],
        'participant': value['participant'],
        'freelancerWorkedUnit': WorkedUnitToJSON(value['freelancerWorkedUnit']),
        'freelancerWorkedRate': value['freelancerWorkedRate'],
        'freelancerWorkedFrequency': value['freelancerWorkedFrequency'],
        'freelancerEstimatedTotalWorkedAmount': value['freelancerEstimatedTotalWorkedAmount'],
        'freelancerLegalDocumentCanBeDownloaded': value['freelancerLegalDocumentCanBeDownloaded'],
        'clientReference': value['clientReference'],
        'renewStatus': value['renewStatus'],
        'invoiceOrderSummaryTypes': value['invoiceOrderSummaryTypes'],
        'projectPeriodRequired': value['projectPeriodRequired'],
        'canAddExtraDocument': value['canAddExtraDocument'],
        'options': ProjectInformationResourceOptionsToJSON(value['options']),
        'clientBelongsToAWalletCompany': value['clientBelongsToAWalletCompany'],
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => ProjectInformationResourceQuoteLinesInnerToJSON(v))),
        'additionalNotes': value['additionalNotes'],
        'freelancerAppraisal': ProjectInformationResourceFreelancerAppraisalToJSON(value['freelancerAppraisal']),
        'validationInfo': ProjectInformationResourceValidationInfoToJSON(value['validationInfo']),
        'budgetConsumption': ProjectInformationResourceBudgetConsumptionToJSON(value['budgetConsumption']),
        'completionRequested': value['completionRequested'],
        'expenseTrackerEnable': value['expenseTrackerEnable'],
        'clientCompanyServiceLevel': value['clientCompanyServiceLevel'],
        'customerSuccessManager': CustomerSuccessManagerResourceToJSON(value['customerSuccessManager']),
    };
}

